var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokStatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5827 8.90398C24.4459 8.03104 24.6205 0 24.6205 0H18.7292V25.3621C18.5807 28.0746 16.338 30.1978 13.6215 30.1978C10.7963 30.1978 8.5061 27.9076 8.5061 25.0824C8.5061 22.2573 10.7963 19.9671 13.6215 19.9671C14.2177 19.9671 14.8093 20.0713 15.3697 20.2751L15.4275 13.5789C14.8039 13.4731 14.1725 13.42 13.54 13.42C7.30471 13.42 2.25 18.4747 2.25 24.71C2.25 30.9453 7.30471 36 13.54 36C19.5624 36 24.5246 31.273 24.8167 25.2577V12.0466C24.8167 12.0466 28.0541 14.84 33.5827 14.9564V8.90398Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokStatic);
export default __webpack_public_path__ + "static/media/tiktok-static.ee957bcea13b4455f3bef41d4873debf.svg";
export { ForwardRef as ReactComponent };